import { render } from "./StartEvent.vue?vue&type=template&id=6e26d2aa"
import script from "./StartEvent.vue?vue&type=script&lang=js"
export * from "./StartEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__